'use client';

import { MoonIcon, SunIcon } from '@radix-ui/react-icons';
import { useTheme } from 'next-themes';
import { Button } from '@/components/ui/button';

export function ThemeToggle() {
    const { theme, setTheme } = useTheme();

    const handleThemeChange = () => {
        const currentTheme = getCurrentTheme();
        const actualTheme = theme === 'system' ? currentTheme : theme;
        if (actualTheme === 'light') setTheme('dark');
        else setTheme('light');
    };

    const getCurrentTheme = () => {
        if (typeof window !== 'undefined') {
            const isDarkMode = window.matchMedia('(prefers-color-scheme: dark)').matches;
            return isDarkMode ? 'dark' : 'light';
        }
        // Default to light mode if window is not defined (e.g., server-side rendering)
        return 'light';
    };

    return (
        <Button variant="ghost" size="icon" onClick={handleThemeChange}>
            <SunIcon className="h-[1.2rem] w-[1.2rem] rotate-0 scale-100 transition-all dark:-rotate-90 dark:scale-0" />
            <MoonIcon className="absolute h-[1.2rem] w-[1.2rem] rotate-90 scale-0 transition-all dark:rotate-0 dark:scale-100" />
            <span className="sr-only">Toggle theme</span>
        </Button>
    );
}
